import { isDev } from '#configuration/env.ts';

const getLogLevel = () => {
    const { localStorage } = window;
    return localStorage.getItem('logLevel');
};

/**
 * You can activate trace logging in production by adding `logLevel` to localStorage and setting it to `trace`.
 */
export const trace =
    isDev || getLogLevel() === 'trace' ? (...args: unknown[]) => console.log('[src/index]', ...args) : () => {};
